__turbopack_context__.v({
  "item": "Breadcrumbs-module-scss-module__RcKjRa__item",
  "link": "Breadcrumbs-module-scss-module__RcKjRa__link",
  "list": "Breadcrumbs-module-scss-module__RcKjRa__list",
  "mobileHidden": "Breadcrumbs-module-scss-module__RcKjRa__mobileHidden",
  "root": "Breadcrumbs-module-scss-module__RcKjRa__root",
  "separator": "Breadcrumbs-module-scss-module__RcKjRa__separator",
});
